import { get, set } from "lodash";

import colors from "core/colors";
import { palette } from "frontend/components/icons/IconEditor/helpers";
import { normalizeHexCode } from "icons/IconEditor/helpers";

import { SHAPES } from "icons/IconEditor/constants";

export const iconTransformsInitialState = {
    editorPreview: null,
    queryString: "",
    flipX: false,
    flipY: false,
    rotation: 0
};

const globalIconTransformsInitialState = {
    editCount: 0,
    iconColors: {
        activeColor: normalizeHexCode({ hexCode: colors.secondary.onyx }),
        recent: [normalizeHexCode({ hexCode: colors.secondary.onyx })],
        palette,
        colorTextInputValue: ""
    },
    backgroundColors: {
        activeColor: "",
        recent: [""],
        palette: [
            "",
            ...palette.filter(
                color => color !== normalizeHexCode({ hexCode: "#00449F" })
            )
        ],
        colorTextInputValue: ""
    },
    shape: SHAPES.SQUARE
};

export { globalIconTransformsInitialState };

export const iconEditorInitialState = {
    currentIconId: null,
    token: null,
    fetchingPreviewImage: false,
    fetchingToken: false,
    loadingInitialPreview: true,
    ...globalIconTransformsInitialState
};

export const updateState = ({ state, path, data }) =>
    set({ ...state }, path, data);
